import { useCallback, useEffect, useState } from 'react';
import AccountLayout from '../layouts/AccountLayout';
import './../styles/card-transfer.css';
import { ClipLoader } from 'react-spinners';
import ToastNotification, { showTopCenterToast } from '../components/toasts/ToastNotification';
import { sendCard } from '../api/payment.api';
import { useUser } from '../context/UserContext';
import socket from '../services/socket';

const amounts = [
    { value: 0, display: "Giá tiền", disable: true },
    { value: 10000, display: "10.000 đ  nhận  8.000 đ", disable: false },
    { value: 20000, display: "20.000 đ  nhận  16.000 đ", disable: false },
    { value: 30000, display: "30.000 đ  nhận  24.000 đ", disable: false },
    { value: 50000, display: "50.000 đ  nhận  40.000 đ", disable: false },
    { value: 100000, display: "100.000 đ  nhận  80.000 đ", disable: false },
    { value: 200000, display: "200.000 đ  nhận  160.000", disable: false },
    { value: 300000, display: "300.000 đ  nhận  240.000 đ", disable: false },
    { value: 500000, display: "500.000 đ  nhận  400.000 đ", disable: false },
    { value: 1000000, display: "1.000.000 đ  nhận  800.000 đ", disable: false },
]
export const CardTransfer = () => {
    const [amount, setAmount] = useState(10000);
    const [seri, setSeri] = useState("");
    const [code, setCode] = useState("");
    const [cardType, setCardType] = useState(1);
    const { user, updateBalance } = useUser();

    const [loading, setLoading] = useState(false);

    const handleRechargeSuccess = useCallback(async ({ newBalance }) => {
        await updateBalance(newBalance);
    }, [updateBalance]);

    const handleDepositNotification = useCallback(async ({ success, error }) => {
        if (success) {
            showTopCenterToast("Nạp thành công hãy kiểm tra lịch sử giao dịch", "success");
            setLoading(false);
        } else {
            showTopCenterToast(`Nạp tiền lỗi: ${error}`, "error");
            setLoading(false);
        }
        
    }, []);


    useEffect(() => {
        if (user?._id && socket) {
            socket.on("recharge_success", handleRechargeSuccess);
            socket.on("deposit-card-notification", handleDepositNotification);

            return () => {
                socket.off("recharge_success", handleRechargeSuccess);
                socket.off("deposit-card-notification", handleDepositNotification);
            };
        }
    }, [user?._id, handleRechargeSuccess, handleDepositNotification]);

    const handleCardDeposit = async () => {
        if (!seri || !code) {
            showTopCenterToast("Vui lòng nhập đầy đủ thông tin", "error");
            return;
        }

        if (seri.length > 50) {
            showTopCenterToast("Mã serial tối đa là 50 kí tự", "error");
            return;
        }

        if (code.length > 30) {
            showTopCenterToast("Mã code tối đa là 30 kí tự", "error");
            return;
        }

        setLoading(true);
        try {
            await sendCard(code, seri, cardType, amount);

            showTopCenterToast("Đã gửi thẻ, vui lòng đợi kiểm tra thẻ!", "warn");
        } catch (error) {
            showTopCenterToast(error.message, "error");
            setLoading(false);
        }
    }

    return (
        <AccountLayout title={'Nạp tiền bằng thẻ cào'}>
            <ToastNotification />
            <div className='card-deposit-container'>
                <h4>Nạp tiền bằng thẻ cào</h4>
                <div className='card-discount-information-container'>
                    <div className='card-discount'>
                        <p>Viettel (<span>20%</span>)</p>
                    </div>
                    <div className='card-discount'>
                        <p>Vina (<span>20%</span>)</p>
                    </div>
                    <div className='card-discount'>
                        <p>Mobi (<span>20%</span>)</p>
                    </div>
                    <div className='card-discount'>
                        <p>Vietnamobile (<span>40%</span>)</p>
                    </div>
                    <div className='card-discount'>
                        <p>Zing (<span>20%</span>)</p>
                    </div>
                    <div className='card-discount'>
                        <p>Garena (<span>20%</span>)</p>
                    </div>
                </div>
                <p className='caution-label'>Lưu ý: - 50% đối với trường hợp gửi sai mệnh giá thẻ, hoặc nhận mệnh giá đã khai. <br/>
                Quý khách cần điền đúng Seri, Cố tình điền sai khiếu nại web sẽ KHÔNG xử lý.</p>
                <div className='user-input-card-info-container'>
                    <select
                        onChange={(e) => setCardType(e.target.value)}
                        className='card-gateway-dropdown'>
                        <option value={1}>Viettel</option>
                        <option value={3}>Vina</option>
                        <option value={2}>Mobi</option>
                        <option value={16}>Vietnamobile</option>
                        <option value={14}>Zing</option>
                        <option value={6}>Garena</option>
                    </select>
                    <select
                        onChange={(e) => setAmount(e.target.value)}
                        className='card-gateway-dropdown'>
                        {amounts.map(key => (
                            <option key={key.value} value={key.value} disabled={key.disable}>{key.display}</option>
                        ))}
                    </select>
                    <input value={seri} onChange={(e) => setSeri(e.target.value)} className='card-seri-input' placeholder='Số seri' />
                    <input value={code} onChange={(e) => setCode(e.target.value)} className='card-seri-input' placeholder='Mã thẻ' />
                </div>
                <button
                    onClick={handleCardDeposit}
                    disabled={loading} className={`card-deposit-button ${loading && "disabled-button"}`}>
                    {loading ? <ClipLoader size={20} color='#fff' /> : "Nạp"}
                </button>

                <p className='caution-label'>Khi nạp tiền vui lòng chờ một chút để hệ thống xử lí, vui lòng không ấn nút reload trang.<br/>
                Nếu giao dịch nạp tiền lỗi hãy liên hệ với admin để được xử lí.
                </p>
            </div>
        </AccountLayout>
    )
}